import DataTablesBase from '../datatables.js';

const Events = new DataTablesBase();

export default Events;